import { EllipsisMenuButton, Menu, MenuContent, MenuTrigger } from '@optiaxiom/react';
import { IconPenToSquare, IconTrashCan } from '@optimizely/axiom-icons';

type ActionsCellProps = {
  onEdit: () => void;
  onDelete: () => void;
};

export const ActionsCell = ({ onEdit, onDelete }: ActionsCellProps) => {
  return (
    <Menu
      options={[
        {
          label: 'Edit',
          intent: 'neutral',
          execute: onEdit,
          addon: <IconPenToSquare />,
        },
        {
          label: 'Delete',
          intent: 'danger',
          execute: onDelete,
          addon: <IconTrashCan />,
        },
      ]}
    >
      <MenuTrigger asChild>
        <EllipsisMenuButton appearance="subtle" aria-label="Actions menu" />
      </MenuTrigger>
      <MenuContent />
    </Menu>
  );
};
